import React from 'react';
// template components
import BulletedList from '@nmx/template/dist/componentLibrary/components/BulletedList';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';

export default () => (
  <SectionContainer
    id='ltc-insurance-faq-submit-a-claim'
    backgroundVariant='lightA'
    themeType='lightTheme'>
    <Row align='center'>
      <Col
        medium={10}
        large={8}>
        <Typography
          component='h2'
          align='center'
          nextElement='typography'>
          Submit a Claim
        </Typography>
        <Typography
          component='h3'
          nextElement='typography'>
          If you&#39;re asking yourself <WidowBlock>questions like:</WidowBlock>
        </Typography>
        <BulletedList
          bulletType='filledCircle'
          bulletedListData={[
            { bulletText: <>How do I begin the claim process&#63;</> },
            { bulletText: <>Does this health care expense apply toward the policy&#63;</> },
            { bulletText: <>Am I &#40;or the person I represent&#41; eligible to receive benefits on the policy&#63;</> },
            { bulletText: <>Am I eligible for respite care service&#63;</> },
          ]}
        />
        <Typography disableBottomPadding>
          To inform Northwestern Mutual of a Long&#45;Term Care claim, please complete&nbsp;
          <Link
            id='inform-northwestern-mutual-ltc-care-claim'
            variant='primaryDeemphasize'
            linkUrl='/notice-of-long-term-care-form/'>
            this form
          </Link>
          &nbsp;or contact the Northwestern Long&#45;Term Care Claims Administration Office at&nbsp;
          <Link
            id='ltc-claims-admin-office-link'
            variant='primaryDeemphasize'
            linkUrl='tel:8007489493'
            ariaLabel='Call the toll free credit report line'
            noWrap>
            1&#45;800&#45;748&#45;9493
          </Link>. Our staff will answer your questions and assist you with all aspects of claims management.
        </Typography>
      </Col>
    </Row>
  </SectionContainer>
);
